/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Folder } from '../../models/folder';

export interface FolderControllerFindFolderById$Params {
  folderId: string;
}

export function folderControllerFindFolderById(http: HttpClient, rootUrl: string, params: FolderControllerFindFolderById$Params, context?: HttpContext): Observable<StrictHttpResponse<Folder>> {
  const rb = new RequestBuilder(rootUrl, folderControllerFindFolderById.PATH, 'get');
  if (params) {
    rb.path('folderId', params.folderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Folder>;
    })
  );
}

folderControllerFindFolderById.PATH = '/folder/id/{folderId}';
